import { render, staticRenderFns } from "./Inventory.vue?vue&type=template&id=36c469f4&"
import script from "./Inventory.vue?vue&type=script&lang=js&"
export * from "./Inventory.vue?vue&type=script&lang=js&"
import style0 from "./Inventory.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports